import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default (sign = '$') => {
  return createNumberMask({
    prefix:                   sign,
    suffix:                   '',
    thousandsSeparatorSymbol: ''
  });
};
